var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(" This sign in request has expired. ")]),_c('div',{staticClass:"text"},[_c('p',[_vm._v("Please open Axure RP and try again.")])])])
}]

export { render, staticRenderFns }